// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BannerA_TheComp__FI_oH"};